import React, { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { ParentsMenus } from "../../components/recoil/atoms/Menus";

import HeaderUserTitle from "../components/includes/HeaderUserTitle";
import SelectChildrens from "../components/popups/SelectChildrens";
import TopChildrenStatus from "../components/includes/TopChildrenStatus";
import { PassedMonths,ChangeSimpleDateString,GetChildrenState,LoginAfterCheckLogin,isObjEmpty,isNull } from "../../components/common/Common";

import "../../css/style.css";

//수료증 발급내역
const Certificates = () => {
  LoginAfterCheckLogin(1);  //로그인 상태 점검
  const mem_idx = Number(localStorage.getItem('mem_idx'));

  const navigate = useNavigate();
  const [varParentMenus,setParentMenus] = useRecoilState(ParentsMenus);

  //원생정보
  const [varChildrenInfo,setChildrenInfo] = useState({});
  const [varChildrenList,setChildrenList] = useState([]);
  const [varChildrenIndex,setChildrenIndex] = useState(0);

  //수료증정보
  const [varTotalCount,setTotalCount] = useState(0);
  const [varCertificationList,setCertificationList] = useState([]);

  //원생정보호출
  const GetChildrenList = async() => {
    const sendData = {mem_idx:mem_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_member_childrens`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        if(datas.results.length > 0) {
          const parents = datas.results;
          setChildrenList(parents);
          
          //원생 선택
          const childInfo = parents.find(el=>el.ch_idx===varChildrenIndex);
          setChildrenInfo(childInfo);

          GetCertificationList();
        }
      } else {
        alert(datas.message);
      }
    });
  }

  //원생별 수료증 발급내역 가져오기
  const GetCertificationList = async() => {
    const sendData = {ch_idx:varChildrenIndex};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/parent_get_certificate_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setTotalCount(datas.results.length);
        if(datas.results.length > 0){
          const childrens = datas.results;
          setCertificationList(childrens);
        } else {
          setCertificationList([]);
        }
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varParentMenus);
    setParentMenus({showMenu:false,gotoMain:0});
    //원생고유번호
    let ch_idx = 0;
    if(!isNull(localStorage.getItem('childrenIndex'))) ch_idx = Number(localStorage.getItem('childrenIndex'));
    setChildrenIndex(ch_idx);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if(varChildrenIndex > 0) GetChildrenList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varChildrenIndex]);

  //발급신청
  const onShowCertificateHandler = (e,ce_idx) => {
    navigate(`/Parents/CertificateView/${ce_idx}`);
  }

  //원생교채
  //원생선택 팝업창--------------------------------------------------------
  const [varPopupChildrens,setPopupChildrens] = useState(false);
  const onChangeChildrenHandler = (e) => {
    setPopupChildrens(true);
  }
  const ClosePopupChildrens = () => {
    setPopupChildrens(false);
  }
  const SelectChildrenHandler = (ch_idx) => {
    console.log(ch_idx);
    setPopupChildrens(false);
    //원생선택
    setChildrenIndex(ch_idx);
    localStorage.setItem('childrenIndex',ch_idx);
  }

  return (
    <div className="vh-content">
      <HeaderUserTitle varPageTitle={'수료증'} varBackString={'/Parents/MyPage'}/>
      <div className="vh-content-body">
        {/* 원생정보 */}
        {isObjEmpty(varChildrenInfo)?null:
            <TopChildrenStatus varClasses={'user-info2'} varChildrenInfo={varChildrenInfo} varChildrenList={varChildrenList} onChangeChildrenHandler={onChangeChildrenHandler} />
        }
        <div className="cl-certi-wrap">
          <div className="center-wrap">
            <div className="search-ok-con">
              <div className="top-line2">
								<p>전체 {varTotalCount}건</p>
							</div>
              {varCertificationList.map((certificates,i)=>(
                <div key={'certificates_'+i} className="con-box">
                  <div className="txt-box">
                    <div className="kids-line">
                      <p className="kids">{certificates.ch_name} {PassedMonths(certificates.ch_birthday)+"개월"}</p>
                      <div className="date">{ChangeSimpleDateString(certificates.ch_birthday)} ({GetChildrenState(certificates.ch_status)})</div>
                    </div>
                    <div className="flex">
                      <p>출석회차</p><div>{certificates.ch_attendance}회</div>
                    </div>
                    <div className="flex">
                      <p>발급일자</p><div>{ChangeSimpleDateString(certificates.ce_pdate)}</div>
                    </div>
                    <div className="flex">
                      <p>발급종류</p>
                      <div>
                        {certificates.vl_name} ({certificates.ce_lang===1?"국문":"영문"})
                      </div>
                    </div>							
                  </div>
                  <button className="btn-st01" onClick={e=>onShowCertificateHandler(e,certificates.ce_idx)}>보기</button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <SelectChildrens varChildrenIndex={varChildrenIndex} varPopupChildrens={varPopupChildrens} varChildrenList={varChildrenList} ClosePopupChildrens={ClosePopupChildrens} SelectChildrenHandler={SelectChildrenHandler}/>
    </div>	
  );
}
export default Certificates;